import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import { TiEdit, TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import { FcPlus } from "react-icons/fc";

import { Container, Row, Col, Button, Stack } from "react-bootstrap";

import ProjectDataService from "../../services/project.service";
import { useAuthContext } from "../../contexts/AuthContext";
// import ReactTooltip from "react-tooltip";
// import { TiEdit, TiDeleteOutline, TiEyeOutline } from "react-icons/ti";

import "./Project.scss";

function Projects() {
  const navigate = useNavigate();
  const { setIsLoading } = useAuthContext();

  const [projectList, setProjectList] = useState();

  useEffect(() => {
    retrieveProjectDetails();
  }, []);

  function retrieveProjectDetails() {
    setIsLoading(true);
    ProjectDataService.getByUser().then((response) => {
      setIsLoading(false);
      setProjectList(response.data.data);
    });
  }

  function deleteProject(id) {
    setIsLoading(true);
    ProjectDataService.delete(id).then((response) => {
      setIsLoading(false);
      const updatedProject = projectList.filter((item) => item.id !== id);
      setProjectList(updatedProject);
    });
  }

  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}>
          <h1 className="mt-4 pageTitle">Projects List</h1>
        </Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={1}>
            <Button
              variant="primary"
              className="mt-4"
              onClick={() => navigate("/projects/create")}
            >
              <FcPlus /> Create Project
            </Button>
          </Stack>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          {projectList && projectList.length ? (
            <Table bordered hover>
              <thead>
                <tr>
                  <th sm="1">#</th>
                  <th>Project Name</th>
                  <th>Database Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {projectList.map((item, index) => {
                  return (
                    <tr key={index.toString()}>
                      <td>{index + 1}</td>
                      <td>{item.projectName}</td>
                      <td>{item.databaseType}</td>
                      <td className="action">
                        <Stack direction="horizontal" gap={3}>
                          <Link
                            className="text-primary"
                            data-tip
                            data-for="detailTip"
                            to={"/projects/" + item.id}
                          >
                            <TiEyeOutline size="25" />
                          </Link>
                          <Link
                            className="text-success"
                            data-tip
                            data-for="editTip"
                            to={"/projects/edit/" + item.id}
                          >
                            <TiEdit size="25" />
                          </Link>
                          <Button
                            variant="link"
                            className="danger"
                            onClick={() => deleteProject(item.id)}
                          >
                            <TiDeleteOutline size="25" />
                          </Button>
                        </Stack>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <Table striped bordered hover>
              <tbody>
                <tr>
                  <td colSpan="3" className="text-center">
                    No Project Found
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Projects;
